
<h1>Méthode d'inscription</h1>
<p>
  Choisissez une méthode parmi les choix suivant.
</p>
<a href="javascript://" (click)="selectMethod.emit('code')" class="d-block p-1 m-0">
  <i class="fa fa-angle-right"></i> Je suis détenteur d'un code d'accès
</a>
<a href="javascript://" (click)="selectMethod.emit('contract')" class="d-block p-1 m-0">
  <i class="fa fa-angle-right"></i> Je suis détenteur d'un numéro de contrat
</a>
<a href="javascript://" (click)="selectMethod.emit('email')" class="d-block p-1 m-0">
  <i class="fa fa-angle-right"></i> Je souhaite m'inscrire directement
</a>
<button kendoButton="" class="mt-4" routerLink="/auth/login/email">Retour</button>



// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/auth/register/components/choose-method/choose-method.component.html